import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Button from "../../components/inputs/button";
import xGreenIcon from "../../assets/svgs/x-green.svg";

export const FEEDBACK_REASONS = [
	{ value: "not_relevant", label: "Not relevant" },
	{ value: "too_broad", label: "Too broad" },
	{ value: "too_narrow", label: "Too narrow" },
	{ value: "missing_key_criteria", label: "Missing key criteria" },
	{ value: "inaccurate_details", label: "Inaccurate details" },
	{ value: "other", label: "Other" },
];


function FeedbackModal({ audienceName, onSubmit, onClose }) {
	const [selectedReasons, setSelectedReasons] = useState([]);
	const [details, setDetails] = useState("");

	useEffect(() => {
		const handleKeyDown = (e) => {
			if (e.key === "Escape") onClose();
		};
		document.addEventListener("keydown", handleKeyDown);
		return () => document.removeEventListener("keydown", handleKeyDown);
	}, [onClose]);

	const toggleReason = (value) => {
		setSelectedReasons((prev) =>
			prev.includes(value)
				? prev.filter((r) => r !== value)
				: [...prev, value]
		);
	};

	const handleSubmit = () => {
		onSubmit(
			selectedReasons.length > 0 ? selectedReasons : null,
			details.trim() || null,
		);
	};

	return (
		<div className="feedback-modal-overlay" onClick={onClose}>
			<div className="feedback-modal" onClick={(e) => e.stopPropagation()}>
				<div className="modal-header">
					<h2>What didn&apos;t you like about this result?</h2>
					<button type="button" className="close-btn" onClick={onClose}>
						<img src={xGreenIcon} alt="Close" />
					</button>
				</div>

				<div className="modal-body">
					{audienceName && (
						<p className="feedback-modal-audience">{audienceName}</p>
					)}

					<p className="feedback-modal-subtitle">Select all that apply.</p>

					<div className="feedback-reasons">
						{FEEDBACK_REASONS.map((reason) => (
							<label key={reason.value} className="feedback-reason-item">
								<input
									type="checkbox"
									checked={selectedReasons.includes(reason.value)}
									onChange={() => toggleReason(reason.value)}
								/>
								<span className="checkmark"></span>
								<span className="reason-label">{reason.label}</span>
							</label>
						))}
					</div>

					<div className="feedback-details-field">
						<label htmlFor="feedback-details">Additional details (optional)</label>
						<textarea
							id="feedback-details"
							value={details}
							onChange={(e) => setDetails(e.target.value)}
							rows={3}
							placeholder="What could be improved about this audience?"
						/>
					</div>
				</div>

				<div className="modal-footer">
					<button type="button" className="cancel-link" onClick={onClose}>
						Cancel
					</button>
					<Button
						text="Submit Feedback"
						type="button"
						style="dark"
						disabled={false}
						loaded={false}
						onClick={handleSubmit}
					/>
				</div>
			</div>
		</div>
	);
}

FeedbackModal.propTypes = {
	audienceName: PropTypes.string,
	onSubmit: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
};

export default FeedbackModal;
